<template>
  <div class="dashboard">
    <kakaoMap :monList="kmon" />
  </div>
</template>

<script>
import kakaoMap from "../components/KakaoMap";
import ax from "@/api/car";

export default {
  name: "Home",

  components: {
    kakaoMap
  },

  data() {
    return {
      kmon: []
    };
  },

  methods: {
    getVdbList() {
      ax.vdbList(rs => {
        if (rs) {
          this.kmon = rs.item;
          // this.kmon = [
          //   {
          //     bacp: "16279.5",
          //     badp: "15755.5",
          //     brand: "현대",
          //     brk: "1",
          //     bsoc: "57.5",
          //     bsoh: "100.0",
          //     c_date: "2024-03-15 13:02:13",
          //     c_state: "01",
          //     gps_x: "126.831188",
          //     gps_y: "33.255382",
          //     id: "01200000000",
          //     idx: "3",
          //     indate: "2024-03-15 13:02:22",
          //     model: "아이오닉",
          //     num: "테스60트1234",
          //     t_dist: 76906,
          //     year: "2019"
          //   }
          // ];
        } else {
          console.log("err: 데이터를 읽어오지 못했습니다.");
        }
      });
    }
  },

  created() {
    this.getVdbList();
  },

  mounted() {
    setInterval(this.getVdbList, 10000);
  }
};
</script>

<style>
.dashboard {
  width: 100%;
  height: 100vh;
}
</style>
